import Rating from 'react-rating';
import { useTranslation } from "react-i18next";


function BusinessItem(props: any) {
  // const { user } = AppStateHandler.getState();
  const { t, i18n } = useTranslation();
  const { setPostData, setModalVisibility, setDetailView, ...item } = props;
  const { images, title, likes, total_comments, message } = item;
  const imgUrl = images.length ? images[0].url : "";
  const detailViewHandler = () => {
    setPostData(item);
    setDetailView(true);
  };

  return (
    <div className="col-md-4 cursor-pointer" onClick={detailViewHandler}>
      <div className="col_selector">
        <div className={`furniture_card ${i18n.dir()==='rtl'?'text-right':''}`}>
          <img src={imgUrl} className="img-fluid w-100" alt="" />
          <p className="fz12 mb-0 poppinsbold  pt-2 px-2 pb-3">{title}</p>
          <p className={`fz12 mb-0 px-2 py-1 ${i18n.dir()==='rtl'?'Almarairegular':'poppinsregular'}`}>
          <Rating className="text-warning"
            emptySymbol="fa fa-star-o "
            fullSymbol="fa fa-star"
            fractions={2}
            initialRating={likes}
            readonly
          />{"  "}
           {total_comments + " " + t('Reviews')}
          </p>
          <p className="fz11 mb-0 poppinsregular px-2 pt-1 pb-3">{message}</p>
        </div>
      </div>
    </div>
  );
}

export default BusinessItem;
